export const isInt = (value) => {
  return parseInt(value, 10) === value
}

export const isFloat = (value) => {
  return parseFloat(value) === value
}



// WEBPACK FOOTER //
// ./src/helpers/validation.js